export default "__VITE_ASSET__cd9ca8e2__"